<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <!-- KOMITENT -->
        <div class="form-group row">
          <div class="col-md-12">
            <yt-dropdown-picklist
              [ModelName]="'komitent'"
              [GetName]="'get'"
              [ModelProperty]="'SNaziv,Mesto'"
              [OrderBy]="'SNaziv'"
              [AllowAddNew]="false"
              [AllowEdit]="false"
              formControlName="KomitentID"
              [Label]="'KOMITENTVOZILO.KOMITENT.SINGULAR'"
              [Width]="'150%'"
              [Position]="'left'"
              (OnItemSelected)="onKomitentSelect($event)"
              #cmbKomitent
              #autofocus>
            </yt-dropdown-picklist>

            <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
              <span *ngFor="let validation of errorMessages.KomitentID">
                <span class="error-message"
                      *ngIf="fc.KomitentID.hasError(validation.type)">
                  <span translate="{{ validation.message }}"></span>
                </span>
              </span>
            </div>
          </div>
        </div>

        <!-- REGISTARSKI BROJ -->
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input
              [Type]="'text'"
              name="txtRgBr"
              formControlName="RgBr"
              #txtRgBr
              [MaxLength]="20"
              [ngClass]="{ 'is-invalid': submitted && fc.RgBr.invalid }"
              [Label]="'KOMITENTVOZILO.RGBR.SINGULAR'"
            >
            </yt-input>

            <div class="form-error" *ngIf="submitted && fc.RgBr.invalid">
              <span *ngFor="let validation of errorMessages.RgBr">
                <span class="error-message"
                      *ngIf="fc.RgBr.hasError(validation.type)">
                  <span translate="{{ validation.message }}"></span>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
